import { defaults } from './env-defaults';
import { PortalAppEnvironment } from '@nuso/portal/environments';

export const environment: PortalAppEnvironment = {
  ...defaults,
  envName: 'dev',
  sentry: 'https://3f4b347116b840f286c4c654d0955214@sentry.io/1192568',
  customerTestingEnabled: true,
  salesforceSupportEnabled: true,
};
